export const hasEditor = process.env.NODE_ENV === 'development'
                      && process.env.VUE_APP_EDITOR === 'true'

export default {
  hasEditor
}
